import { API } from 'aws-amplify';
import type { Account } from './account';
import type { GraphQLQuery } from '@aws-amplify/api';

export const getUserIdByAccount = async (account: Account) => {
	const pgUsers = await API.graphql<GraphQLQuery<any>>({
		query: /* GraphQL */ `
			query AllPgUsers($filter: PgUserFilter) {
				allPgUsers(filter: $filter) {
					nodes {
						id
						email
					}
				}
			}
		`,
		variables: { filter: { providerUserId: { _eq: account.username } } }
	});

	// get user id from database
	return pgUsers.data.allPgUsers.nodes[0];
};
